import Client from "./Client";
// import RequestList from "./RequestList";

const Service = {
    url: 'admin/accounting-receipts',
    getDefault(){
        return {
            settlement_request_id: undefined,
            file_id: undefined,
            amount: undefined,
            paid_at: undefined,
            created_at: undefined,
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },
    /**
     * @params accountingReceipt
     * @return Request Promise
     **/
    async create(model) {
        return await Client.post(`${this.url}`, model);
    },
    /**
     * @params accountingReceipt
     * @return Request Promise
     **/
    async delete(id) {
        return await Client.post(`${this.url}` + '/' + id + '/delete');
    },
}

export default Service